// Date grouping + timestamp formatting for the HIST/FAVS panel.
// All values are local time zone. Timestamps are always 12-hour with AM/PM.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

// "hh:mm:ss AM/PM" in the user's local time zone (Story §4).
export const formatTime = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleTimeString([], {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
    });
};

// Today / Yesterday / "Mon D" (this year) / "Mon D, YYYY" (prior years).
export const groupLabel = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';

    const now = new Date();
    const today = startOfDay(now);
    const oneDay = 24 * 60 * 60 * 1000;
    const target = startOfDay(d);

    if (target === today) return 'Today';
    if (target === today - oneDay) return 'Yesterday';

    const monthDay = `${MONTHS[d.getMonth()]} ${d.getDate()}`;
    return d.getFullYear() === now.getFullYear() ? monthDay : `${monthDay}, ${d.getFullYear()}`;
};

// Groups already-sorted (most-recent-first) entries into ordered date sections.
// Only groups that contain entries are returned, so headers never render empty
// (Story §5).
export const groupByDate = (entries = []) => {
    const groups = [];
    const byLabel = new Map();

    entries.forEach((entry) => {
        const label = groupLabel(entry.executedAt);
        if (!byLabel.has(label)) {
            const group = { label, items: [] };
            byLabel.set(label, group);
            groups.push(group);
        }
        byLabel.get(label).items.push(entry);
    });

    return groups;
};
